import utils from "./functionTools";
// 设置dpr与rem适配
const docEl = document.documentElement;
const metaEl = docEl.querySelector('meta[name = "viewport"]');
const deviceWidth = docEl.clientWidth;
const dpr = window.devicePixelRatio || 1;
const rem = device.desktop() ? 50 : (deviceWidth * dpr) / 10;
const scale = 1 / dpr;
// 设置dpr标识 作hack
docEl.setAttribute("data-dpr", dpr);

// metaEl.setAttribute('content', 'width=' + dpr * deviceWidth + ',initial-scale = ' + scale + ',maximum-scale=' + scale + ',minimum-scale=' + scale + ',user-scalable = no')
metaEl.setAttribute(
  "content",
  `width=${dpr *
    deviceWidth},initial-scale = ${scale},maximum-scale=${scale},minimum-scale=${scale},user-scalable = no`
);
docEl.style.fontSize = rem + "px";
//判断是否在小程序
const isMiniProgram = utils.getUrlParam("isMiniProgram") === "1";
if (isMiniProgram) {
  // 设置dpr标识 作hack
  docEl.removeAttribute("data-dpr");
  metaEl.setAttribute(
    "content",
    `width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, minimal-ui`
  );
  docEl.style.fontSize = "37.5px";
}



// WEBPACK FOOTER //
// ./src/starcharge/utils/fontSize.js